<mat-expansion-panel
  class="mat-elevation-z0"
  [attr.data-id]="item.label"
  [expanded]="expanded()"
  [hideToggle]="collapsed"
  (opened)="onOpened()"
  (closed)="onClosed()"
>
  <mat-expansion-panel-header
    #header
    [class.collasped]="collapsed"
    [class.is-active]="collapsed && menuActive"
    (cdkFocusChange)="onFocus($event, header)"
    cdkMonitorElementFocus
  >
    <mat-panel-title *transloco="let t; prefix: 'sideNav.menu'">
      <rma-icon [glyph]="item.icon" [title]="collapsed ? t(item.label) : ''" />
      @if (!collapsed) {
        <span class="menu-title">{{ t(item.label) }}</span>
      }
    </mat-panel-title>
  </mat-expansion-panel-header>
  @if (!collapsed) {
    <mat-nav-list>
      @for (childItem of item.children; track childItem.label) {
        <rma-nav-menu-item
          class="is-child"
          [item]="childItem"
          [isActive]="childItem | isNavMenuItemActive: currentUrl"
          (navigated)="navigated.emit()"
        />
      }
    </mat-nav-list>
  }
</mat-expansion-panel>
